/**@jsxImportSource theme-ui */
import Popover from '../Popover';
import React from 'react';
import { Placement, PopoverProps } from '../Popover/PopoverTypes';

export type TooltipProps = Omit<PopoverProps, 'trigger' | 'showArrow'>;

type ArrowProps = {
    style?: React.CSSProperties;
    attributes: { [property: string]: string };
    setArrowElement: (el: HTMLElement) => void;
    placement?: Placement;
};

export function Arrow({ style, attributes, setArrowElement }: ArrowProps): JSX.Element {
    return (
        <div
            data-testid="arrow-content"
            ref={setArrowElement}
            sx={{
                width: '15px',
                height: '15px',
                border: '1px solid #cccccc',
                position: 'absolute',
                transform: `${style.transform} rotate(45deg)`,
                background: 'inherit',
                '#popper-content[data-popper-placement^="right"] > &': {
                    left: '-8px',
                    top: `${style.top}`,
                    borderRight: '0',
                    borderTop: '0',
                },
                '#popper-content[data-popper-placement^="left"] > &': {
                    right: '-8px',
                    top: `${style.top}`,
                    borderLeft: '0',
                    borderBottom: '0',
                },
                '#popper-content[data-popper-placement^="top"] > &': {
                    left: `${style.left}`,
                    bottom: '-8px',
                    borderTop: '0',
                    borderLeft: '0',
                },
                '#popper-content[data-popper-placement^="bottom"] > &': {
                    left: `${style.left}`,
                    top: '-8px',
                    borderBottom: '0',
                    borderRight: '0',
                },
            }}
            {...attributes}
        />
    );
}

export function Tooltip({ anchor, content, placement, offset, shadow, ...otherProps }: TooltipProps): JSX.Element {
    return <Popover {...otherProps} {...{ offset, content, placement, anchor, shadow }} trigger="hover" showArrow />;
}

Tooltip.defaultProps = {
    offset: [0, 12],
    placement: 'auto',
    background: 'white',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid #cccccc',
    shadow: 'sheet',
};
